import type { InternalRequest } from '../client.js';

export interface SnapTracePoint {
  lng: number;
  lat: number;
  /** Optional ms-epoch timestamp. Including it improves OSRM's HMM accuracy. */
  time?: number;
}

export interface SnapMatchResponse {
  matched: { lng: number; lat: number }[];
  geometry: { type: 'LineString'; coordinates: [number, number][] } | null;
  confidence: number;
}

export interface SnapHealthResponse {
  ok: boolean;
  detail?: string;
  osrmUrl: string;
  cacheSize: number;
}

export function snapEndpoints(req: InternalRequest) {
  return {
    /** POST /api/snap/match — map-match a per-device trace against OSRM. */
    match: (points: SnapTracePoint[]) =>
      req.request<SnapMatchResponse>('/snap/match', {
        method: 'POST',
        body: JSON.stringify({ points }),
      }),
    /** GET /api/snap/health — admin/sultan only; surfaces OSRM reachability. */
    health: () => req.request<SnapHealthResponse>('/snap/health'),
  };
}
